import React from 'react';
export function FantasyHeader({ blockName, }){
  const classPrefix = `${ blockName }__header`;
  return (
    <header
      className={ `${ classPrefix }` }
    >
      <div className={ `${ classPrefix }-logo-container` }></div>
      <div className={ `${ classPrefix }-label-promotion` }>
        Use Promo Code
        <span className={ `${ classPrefix }-label-promotion-code` }> FANTASY50 </span>
        For &pound;50 Bonus
      </div>
      <a href="https://login.yahoo.com/account/create?src=dailyfantasy&specId=usernameReg&context=reg&intl=GB&.lang=en-GB&.done=https%3A%2F%2Fuk.sports.yahoo.com%2Fdailyfantasy%2F%3F" className={ `${ classPrefix }-sign-up-button` }>SIGN UP</a>
      <div className={ `${ classPrefix }-label-starts-today` }>
        Starts Today
      </div>
    </header>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/components/fantasyHeader.js